import axiosClient from "../axiosClient";

const route = "supplier";

export const getSupplierById = async (supplierId) => {
  try {
    const response = await axiosClient.get(`${route}/${supplierId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getFilteredSuppliers = async (params) => {
  try {
    const response = await axiosClient.get(`${route}/filteredSuppliers`, {
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 5,
        search: params.search,
      },
    });

    return response;
  } catch (error) {}
};

export const uploadSupplierDocuments = async (supplierId, formData) => {
  try {
    const response = await axiosClient.post(
      `${route}/addSupplierFiles`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          id: supplierId,
        },
      }
    );

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierByBank = async (params) => {
  try {
    const response = await axiosClient.get(`${route}/supplierByBank`, {
      params: {
        ...params,
      },
    });
    return response;
  } catch (error) {}
};

export const getSupplierUsingId = async (supplierId) => {
  try {
    const response = await axiosClient.get(`${route}/byId/${supplierId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
